import React, { Children } from 'react';
import { SEO } from '../components/layout/SEO';
import { Section } from '../components/ui/Section';
import { Card, CardContent } from '../components/ui/Card';
import { FadeIn } from '../components/ui/FadeIn';
import { Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function TeamPage() {
  const {
    t
  } = useLanguage();
  const executiveTeam = [{
    name: 'Dr. Ahmed Khan',
    role: 'President',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    specialty: 'Consultant Cardiologist',
    workplace: 'NHS Trust London',
    experience: '20+ years',
    bio: "Dr. Khan has over 20 years of experience in cardiology and has been instrumental in establishing KMA UK's charitable initiatives. He leads our strategic direction and overseas partnerships."
  }, {
    name: 'Dr. Sarah Malik',
    role: 'General Secretary',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    specialty: 'GP Principal',
    workplace: 'London Medical Centre',
    experience: '15 years',
    bio: 'Dr. Malik manages the day-to-day operations of KMA UK and coordinates our events and member communications. She is passionate about community health and medical education.'
  }, {
    name: 'Dr. Mohammad Ali',
    role: 'Treasurer',
    image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    specialty: 'Consultant Neurologist',
    workplace: 'Birmingham City Hospital',
    experience: '18 years',
    bio: 'Dr. Ali oversees all financial matters and ensures transparency in our charitable work. He brings extensive experience in healthcare management and financial governance.'
  }, {
    name: 'Dr. Fatima Shah',
    role: 'Charity Coordinator',
    image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    specialty: 'Consultant Paediatrician',
    workplace: "Manchester Children's Hospital",
    experience: '12 years',
    bio: 'Dr. Shah leads our humanitarian projects and coordinates medical camps in Pakistan. Her dedication to child health has transformed lives in underserved communities.'
  }, {
    name: '[Name to be updated]',
    role: 'Team Member',
    image: 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    specialty: '[Specialty]',
    workplace: '[Place of Work]',
    experience: '[Years]',
    bio: '[Professional bio to be added]'
  }];
  const advisors = [{
    name: 'Dr. Imran Hassan',
    role: 'Advisor',
    specialty: 'Consultant Surgeon',
    workplace: 'Leeds Teaching Hospitals',
    experience: '25 years'
  }, {
    name: 'Dr. Ayesha Rahman',
    role: 'Advisor',
    specialty: 'Medical Educator',
    workplace: 'University of Manchester',
    experience: '22 years'
  }, {
    name: 'Dr. Tariq Mahmood',
    role: 'Advisor',
    specialty: 'Consultant Psychiatrist',
    workplace: 'Sheffield Health',
    experience: '30 years'
  }, {
    name: '[Name to be updated]',
    role: 'Advisor',
    specialty: '[Specialty]',
    workplace: '[Place of Work]',
    experience: '[Years]'
  }];
  return <>
      <SEO title={t('nav.team')} description={t('team.hero.subtitle')} data-id="element-668" />

      <div className="bg-[#1e5f4f] text-white py-16 md:py-20" data-id="element-669">
        <div className="container mx-auto px-4 text-center" data-id="element-670">
          <FadeIn data-id="element-671">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-672">
              Our Leadership Team
            </h1>
            <p className="text-xl text-white max-w-2xl mx-auto" data-id="element-673">
              Dedicated professionals volunteering their time and expertise to
              serve our community and advance our charitable mission.
            </p>
          </FadeIn>
        </div>
      </div>

      {/* Executive Committee */}
      <Section data-id="element-674">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-675">
          <h2 className="text-3xl font-serif font-bold text-primary-900 mb-4" data-id="element-676">
            {t('team.executive.title')}
          </h2>
          <p className="text-gray-600" data-id="element-677">{t('team.executive.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto" data-id="element-678">
          {executiveTeam.map((member, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-679">
              <Card className="h-full border-none shadow-lg hover:shadow-xl transition-shadow flex flex-col" data-id="element-680">
                <div className="aspect-[4/3] overflow-hidden" data-id="element-681">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-682" />
                </div>
                <CardContent className="p-6 flex-1 flex flex-col" data-id="element-683">
                  <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-684">
                    {member.name}
                  </h3>
                  <p className="text-primary-700 font-bold text-sm mb-3 uppercase tracking-wide" data-id="element-685">
                    {member.role}
                  </p>

                  <div className="space-y-1 text-sm text-gray-600 mb-4 bg-gray-50 p-3 rounded-md" data-id="element-686">
                    <p data-id="element-687">
                      <span className="font-semibold" data-id="element-688">
                        {t('team.fields.specialty')}
                      </span>{' '}
                      {member.specialty}
                    </p>
                    <p data-id="element-689">
                      <span className="font-semibold" data-id="element-690">
                        {t('team.fields.workplace')}
                      </span>{' '}
                      {member.workplace}
                    </p>
                    <p data-id="element-691">
                      <span className="font-semibold" data-id="element-692">
                        {t('team.fields.experience')}
                      </span>{' '}
                      {member.experience}
                    </p>
                  </div>

                  <p className="text-gray-600 text-sm leading-relaxed flex-1" data-id="element-693">
                    {member.bio}
                  </p>
                </CardContent>
              </Card>
            </FadeIn>)}
        </div>
      </Section>

      {/* Board of Advisors */}
      <Section background="gray" data-id="element-694">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-695">
          <h2 className="text-3xl font-serif font-bold text-primary-900 mb-4" data-id="element-696">
            {t('team.advisors.title')}
          </h2>
          <p className="text-gray-600" data-id="element-697">{t('team.advisors.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-698">
          {advisors.map((advisor, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-699">
              <Card className="h-full" data-id="element-700">
                <CardContent className="p-6" data-id="element-701">
                  <div className="h-16 w-16 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xl font-bold mb-4" data-id="element-702">
                    {advisor.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-703">
                    {advisor.name}
                  </h3>
                  <p className="text-primary-700 font-medium text-sm mb-3" data-id="element-704">
                    {advisor.role}
                  </p>
                  <div className="text-xs text-gray-500 space-y-1" data-id="element-705">
                    <p data-id="element-706">{advisor.specialty}</p>
                    <p data-id="element-707">{advisor.workplace}</p>
                    <p data-id="element-708">{advisor.experience}</p>
                  </div>
                </CardContent>
              </Card>
            </FadeIn>)}
        </div>
      </Section>

      {/* Charity Number */}
      <Section className="py-8 border-t border-gray-100" data-id="element-709">
        <div className="text-center text-gray-500 text-sm" data-id="element-710">
          <p data-id="element-711">{t('team.charityNumber')}</p>
        </div>
      </Section>

      {/* Contact CTA */}
      <Section className="text-center pt-0" data-id="element-712">
        <FadeIn data-id="element-713">
          <div className="max-w-2xl mx-auto" data-id="element-714">
            <Mail className="h-10 w-10 mx-auto mb-4 text-primary-600" data-id="element-715" />
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-716">
              {t('team.contact.title')}
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-717">{t('team.contact.subtitle')}</p>
            <div className="bg-gray-50 rounded-lg p-6 inline-block" data-id="element-718">
              <p className="text-sm text-gray-600 mb-2" data-id="element-719">
                {t('team.contact.inquiries')}
              </p>
              <a href="mailto:info@kmauk.org" className="text-lg font-semibold text-primary-700 hover:underline" data-id="element-720">
                info@kmauk.org
              </a>
            </div>
          </div>
        </FadeIn>
      </Section>
    </>;
}